import { createContext, useReducer } from "react";

// contex to render the updated data without refresh
// which means all components now have an access to the WP Sitecontext
export const AvailableItemConfigsContext = createContext();

export const availableItemConfigReducer = (state, action) => {
  switch (action.type) {
    case "SET_AVAILABLEITEMCONFIG":
      return {
        ...state,  // Ensure existing state is preserved
        itemConfigs: action.payload,
      };
    case "SET_OPEN_STATUS":  // Add this case to manage open status
      return {
        ...state,  // Preserve existing state
        openStatus: action.payload,
      };
    // case "CREATE_ITEMCONFIG":
    //   return {
    //     itemConfigs: [action.payload, ...state.itemConfigs],
    //   };
    // case "UPDATE_ITEMCONFIG":
    //   return {
    //     itemConfigs: state.itemConfigs.map((itemConfig) =>
    //       itemConfig._id === action.payload._id ? action.payload : itemConfig
    //     ),
    //   };
    // case "DELETE_ITEMCONFIG":
    //   return {
    //     itemConfigs: state.itemConfigs.filter(
    //       (itemConfig) => itemConfig._id !== action.payload._id
    //     ),
    //   };
    default:
      return state;
  }
};

export const AvailableItemConfigsContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(availableItemConfigReducer, {
    itemConfigs: null,
    openStatus: true, // Initialize open status to true
  });
  return (
    <AvailableItemConfigsContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AvailableItemConfigsContext.Provider>
  );
};